import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BottonMenuComponent } from './botton-menu-component';

@NgModule({
  declarations: [
    BottonMenuComponent,
  ],
  imports: [
    IonicPageModule.forChild(BottonMenuComponent),
  ],
  exports : [
    BottonMenuComponent
  ]
})
export class BottonMenuComponentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/components/botton-menu-component/botton-menu-component.module.ts